import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import api from '../../api/axios';
import Breadcrumb from '../../components/ui/Breadcrumb';

const NotarySettings = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [form, setForm] = useState({
    notary_name: '',
    notary_title: '',
    notary_location: '',
    phone: '',
    email: '',
    address: '',
    usd_exchange_rate: '',
  });
  const [logoUrl, setLogoUrl] = useState(null);

  useEffect(() => {
    api.get('/notary-settings').then(res => {
      const d = res.data;
      setForm({
        notary_name: d.notary_name || '',
        notary_title: d.notary_title || '',
        notary_location: d.notary_location || '',
        phone: d.phone || '',
        email: d.email || '',
        address: d.address || '',
        usd_exchange_rate: d.usd_exchange_rate || '',
      });
      if (d.logo_url) setLogoUrl(d.logo_url);
    }).finally(() => setLoading(false));
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.put('/notary-settings', form);
      toast.success('Datos guardados correctamente');
    } catch (error) {
      toast.error('Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingLogo(true);
    try {
      const formData = new FormData();
      formData.append('logo', file);
      const res = await api.post('/notary-settings/logo', formData);
      setLogoUrl(res.data.logo_url);
      toast.success('Logo actualizado');
    } catch (error) {
      toast.error('Error al subir logo');
    } finally {
      setUploadingLogo(false);
      e.target.value = '';
    }
  };

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>;

  return (
    <div className="container-fluid">
      <Breadcrumb items={[{ label: 'Configuración' }, { label: 'Datos de la Notaría' }]} />
      <div className="page-header d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Datos de la Notaría</h4>
      </div>

      <div className="row">
        {/* Logo */}
        <div className="col-12 col-md-3 mb-4">
          <div className="card">
            <div className="card-header"><h6 className="mb-0">Logo</h6></div>
            <div className="card-body text-center">
              <div style={{
                width: '100%', aspectRatio: '1', border: '2px dashed #e5e7eb',
                borderRadius: '12px', display: 'flex', alignItems: 'center',
                justifyContent: 'center', marginBottom: '16px', overflow: 'hidden',
                backgroundColor: '#f9fafb',
              }}>
                {logoUrl ? (
                  <img src={logoUrl} alt="Logo notaría" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', padding: '8px' }} />
                ) : (
                  <div className="text-muted">
                    <svg style={{ width: 40, height: 40, margin: '0 auto 8px', display: 'block' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <small>Sin logo</small>
                  </div>
                )}
              </div>
              <label className="btn btn-outline-primary btn-sm btn-block" style={{ cursor: 'pointer' }}>
                {uploadingLogo ? 'Subiendo...' : 'Subir Logo'}
                <input type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogoUpload} disabled={uploadingLogo} />
              </label>
              <small className="text-muted d-block mt-2">PNG, JPG. Máx 2MB</small>
            </div>
          </div>
        </div>

        {/* Datos */}
        <div className="col-12 col-md-9">
          <form onSubmit={handleSubmit}>
            <div className="card mb-4">
              <div className="card-header"><h6 className="mb-0">Información de la Notaría</h6></div>
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label>Nombre del Notario</label>
                      <input type="text" name="notary_name" className="form-control"
                        placeholder="Lic. Jorge Jaime Cruz Hernandez"
                        value={form.notary_name} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label>Título / Notaría</label>
                      <input type="text" name="notary_title" className="form-control"
                        placeholder="Notaría Pública 84"
                        value={form.notary_title} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label>Ubicación</label>
                      <input type="text" name="notary_location" className="form-control"
                        placeholder="Playa del Carmen, Quintana Roo"
                        value={form.notary_location} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label>Teléfono</label>
                      <input type="text" name="phone" className="form-control"
                        placeholder="(984) 109 3550"
                        value={form.phone} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label>Correo electrónico</label>
                      <input type="email" name="email" className="form-control"
                        placeholder="notaria@ejemplo.mx"
                        value={form.email} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-group">
                      <label>Tipo de cambio USD</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">$</span>
                        </div>
                        <input type="number" name="usd_exchange_rate" className="form-control"
                          placeholder="17.00" step="0.0001" min="0"
                          value={form.usd_exchange_rate} onChange={handleChange} />
                        <div className="input-group-append">
                          <span className="input-group-text">MXN/USD</span>
                        </div>
                      </div>
                      <small className="text-muted">Se usa para convertir presupuestos a dólares</small>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label>Dirección completa</label>
                      <textarea name="address" className="form-control" rows="2"
                        placeholder="Av. 28 de Julio, Mza-16 Lt-1 Local #1, Col. Nueva Creación, Playa del Carmen"
                        value={form.address} onChange={handleChange}></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-wrap" style={{ gap: '10px' }}>
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'Guardando...' : 'Guardar Cambios'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NotarySettings;
